<template>
  <div class="main"
       v-loading="loading"
       element-loading-text="Loading"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(255, 255, 255, 0.3)"
       v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="left-menu">
      <img src="/static/avatar.jpg " class="avatar" v-if="userInfo.image == '' || userInfo.image == null"/>
      <img :src="userInfo.image " class="avatar" v-else/>
      <div class="author-name">{{userInfo.username}}</div>
      <div class="author-info">
        <div>
          <span class="user-address">{{this.$t("common.Area")}}</span><span>{{userInfo.country}}   {{userInfo.city}}</span>
        </div>
        <div>
          <span class="article-number">{{this.$t("common.Total")}}</span><span>{{userInfo.articleNum}}</span>
        </div>
      </div>

    </div>
    <div class="right-section">
      <!--新闻列表-->
      <ul class="newslist-bg">
        <li v-for="item in newsContent" >
          <h3 class="news-title" @click="contentPage(item.id)">{{item.title}}</h3>
          <div class="news-content">
            <p> {{item.description}}</p>
            <!--<div v-if='item.thumbnail !== "" && item.thumbnail !=null'><img :src="item.thumbnail"/></div>-->
            <!--<div v-else></div>-->
          </div>
          <div class="news-time">
          {{item.createTime}}<i>{{$t("userInfo.Views")}}：{{item.hits}}</i>
          </div>
        </li>
      </ul>

      <!--分页-->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="number"
        :page-size="size"
        id="pagination"
        layout="total, prev, pager, next, jumper"
        :total="totalElements">
      </el-pagination>

    </div>
  </div>
</template>

<script>
  import axios from '../axios'

  export default {
    name: "userHomepage",
    data() {
      return {
        loading: true,
        fullscreenLoading: true,
        newsContent: [],
        userInfo: "",
        totalPages: 0,//总页数
        totalElements: 0, //总条数
        size: 0, //当前页条数
        number: 1, //当前页从1开始
        uid: ''
      }
    },
    created: function () {
      this.getUserArticle();
    },

    methods: {
      getUserArticle(currentPage = 1) {
        let _this = this;
        this.uid = this.$route.query.uid;
        axios.get(this.$store.state.apiBasePath + "/user/article?authorId=" + _this.uid + "&page=" + currentPage)
          .then(function (res) {
            var resData = res.data;
            if (resData.code === 200) {
              _this.loading=false;
              _this.fullscreenLoading=false;
              // console.log(resData.data);
              _this.newsContent = resData.data.articleList.content;
              _this.userInfo = resData.data.userInfo;

              _this.totalPages = resData.data.articleList.totalPages;
              _this.totalElements = resData.data.articleList.totalElements;
              _this.number = resData.data.articleList.number + 1;//服务器返回数据从0开始，分页组件从1开始，所以要加1
              _this.size = resData.data.articleList.size;
            } else {
              this.$message({
                title:_this.$t("message.Error"),
                message: res.data.msg,
                type: 'error',
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },

      //点击标题跳转详情页面
      contentPage(id) {
        // this.$router.push({path: "/contentPage/" + id, query: {url: this.url}})
        //跳转新页面 url: this.url传入对应新闻列表参数
        let routeData = this.$router.resolve({path: "/contentPage/" + id});
        // console.log(routeData);
        //点击跳转新页面
        window.open(routeData.href, '_blank');
      },

      //当前页  currentPage 改变时会触发
      handleCurrentChange: function (currentPage) {
        this.number = currentPage;
        this.getUserArticle(currentPage);
      },

    }
  }
</script>

<style scoped>

  .main {
    width: 1170px;
    margin: 15px auto;
    display: flex;
    min-height: calc(100% - 486px);
  }

  .left-menu {
    width: 250px;
    background: #fff;
    border: #e5e5e5 1px solid;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
    margin:30px auto 15px auto;
    border-radius: 50%;
  }

  .author-name {
    font-size: 16px;
    text-align: center;
    border-bottom: #e5e5e5 1px solid;
    padding-bottom: 20px;
    font-weight: bold;
  }
  .author-info {
    display: flex;
    justify-content: space-around;
    margin: 15px 30px;
  }
  .author-info span {
    display: block;
    text-align: center;
  }

  .user-address {
    font-size: 14px;
    color: #238fee;
    display: block;
    margin: 5px 10px;
  }

  .article-number {
    font-size: 14px;
    display: block;
    color: #ff6600;
    margin: 5px 10px;
  }

  .right-section {
    flex: 1;
    padding: 0 10px;
  }


  .newslist-bg {
    text-align: left;
  }

  .newslist-bg li {
    display: block;
    text-decoration: none;
    border: #e5e5e5 1px solid;
    margin: 10px 0;
    padding: 10px 10px;
    background: #fff;
  }

  .newslist-bg li:first-child{
    margin-top: 0;
  }
  .news-title {
    margin: 0 0;
    font-size: 20px;
    color: #000;
  }

  .news-title:hover {
    color: #2990de;
    cursor: pointer;
  }

  .news-content {
    font-size: 14px;
    text-align: justify;
    line-height: 24px;
    color: #2c3e50;
    margin: 10px 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .news-content p {
    margin: 0 15px 0 0;
    overflow: hidden;
  }

  .news-content img {
    height: 100px;
    width: 150px;

  }

  .news-time {
    font-size: 14px;
    color: #666;
  }

  .news-time span {
    color: #009688;
    margin-right: 15px;
  }

  .news-time i {
    font-style: normal;
    margin-left: 15px;
    color: #e60000;
  }



</style>



// WEBPACK FOOTER //
// src/components/userHomepage.vue